<template>
<div class="Card">
</div>
</template>

<script>
export default {
    name: 'Card',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.Card {
}
</style>
